// Storage key prefix for admin wizard drafts
export const ADMIN_WIZARD_DRAFT_KEY_PREFIX = 'admin-tenant-wizard-draft';

// Draft structure for localStorage
export interface AdminWizardDraft {
  data: SerializableAdminFormData;
  step: number;
  savedAt: number;
  businessName: string;
}

// Serializable version (excludes File objects)
export type SerializableAdminFormData = Omit<
  AdminTenantFormData,
  'logoFile' | 'brandGuidelinesFile' | 'fontFiles' | 'documentFiles'
>;

export interface AdminTenantFormData {
  // Step 1: Client Details
  businessName: string;
  contactName: string;
  email: string;
  phone: string;
  industry: string;
  packageType: 'starter' | 'professional';
  useCase: string;

  // Step 2: Website & Developer
  websiteUrl: string;
  additionalUrls: string[];
  developerEmail: string;
  installScope: 'site-wide' | 'specific-pages';
  summaryForwardEmail: string;

  // Step 3: Brand
  useWebsiteAsDesignReference: boolean;
  brandColors: {
    primary: string;
    secondary: string;
    accent: string;
  };
  logoFile: File | null;
  brandGuidelinesFile: File | null;
  fontFiles: File[];

  // Step 4: Documents
  documentFiles: File[];

  // Step 5: Bot Config
  specialisations: string[];
  specialisationsOther: string;
  doNotMention: string;
  internalNotes: string;

  // Step 6: Options
  sendClientNotification: boolean;
}

export const initialFormData: AdminTenantFormData = {
  businessName: '',
  contactName: '',
  email: '',
  phone: '',
  industry: 'accounting',
  packageType: 'starter',
  useCase: '',
  websiteUrl: '',
  additionalUrls: [],
  developerEmail: '',
  installScope: 'site-wide',
  summaryForwardEmail: '',
  useWebsiteAsDesignReference: false,
  brandColors: {
    primary: '#0B1939',
    secondary: '#1a3a5c',
    accent: '#14b8a6',
  },
  logoFile: null,
  brandGuidelinesFile: null,
  fontFiles: [],
  documentFiles: [],
  specialisations: [],
  specialisationsOther: '',
  doNotMention: '',
  internalNotes: '',
  sendClientNotification: true,
};

export const INDUSTRY_OPTIONS = [
  { value: 'accounting', label: 'Accounting' },
  { value: 'legal', label: 'Legal' },
  { value: 'financial-services', label: 'Financial Services' },
  { value: 'professional-services', label: 'Professional Services' },
  { value: 'other', label: 'Other' },
];

export const SPECIALISATION_OPTIONS = [
  { value: 'tax-returns', label: 'Tax Returns & Compliance' },
  { value: 'bookkeeping', label: 'Bookkeeping & Payroll' },
  { value: 'business-advisory', label: 'Business Advisory' },
  { value: 'financial-planning', label: 'Financial Planning' },
  { value: 'audit-assurance', label: 'Audit & Assurance' },
  { value: 'gst-compliance', label: 'GST Compliance' },
  { value: 'company-formations', label: 'Company Formations' },
  { value: 'trust-accounting', label: 'Trust Accounting' },
  { value: 'property-investment', label: 'Property Investment' },
  { value: 'estate-planning', label: 'Estate Planning' },
  { value: 'kiwisaver', label: 'KiwiSaver & Retirement' },
  { value: 'xero-certified', label: 'Xero Certified Partner' },
];
